import { httpsCallable } from "firebase/functions";
import { load } from "@cashfreepayments/cashfree-js";
import { CASHFREE_CONFIG } from "../config/cashfreeConfig";
import { functions } from "../firebase/config";

class CashfreeService {
  async initiatePayment(orderData, userProfile) {
    try {
      // Create order on backend
      const createOrder = httpsCallable(functions, "createCashfreeOrder");
      const orderResponse = await createOrder({
        amount: orderData.amount,
        currency: "INR",
        orderId: orderData.orderId, // Pass the app's order ID to Cashfree
        customerName:
          userProfile.fullName || userProfile.displayName || userProfile.name || "Customer",
        customerEmail: userProfile.email || "",
        customerPhone:
          userProfile.phoneNumber || userProfile.phone || "9999999999",
        notes: {
          description: orderData.description || "",
          userId: userProfile.uid,
        },
      });

      if (!orderResponse.data.success) {
        throw new Error(
          orderResponse.data.error || "Failed to create payment order"
        );
      }

      const { paymentSessionId, orderId } = orderResponse.data;

      // Initialize Cashfree JS SDK
      const cashfree = await load({ mode: CASHFREE_CONFIG.MODE });

      // Open Cashfree checkout modal
      const result = await cashfree.checkout({
        paymentSessionId,
        redirectTarget: "_modal",
      });

      if (result.error) {
        throw new Error(
          result.error.message || "Payment was not completed. Please try again."
        );
      }

      // Verify payment on backend
      const verifyPayment = httpsCallable(functions, "verifyCashfreePayment");
      const verifyResponse = await verifyPayment({ cashfreeOrderId: orderId });

      if (!verifyResponse.data.success) {
        throw new Error("Payment verification failed");
      }

      if (verifyResponse.data.status !== "PAID") {
        throw new Error(
          `Payment status: ${verifyResponse.data.status}. Please contact support if amount was deducted.`
        );
      }

      return {
        success: true,
        orderId,
        paymentId: verifyResponse.data.orderId,
        amount: verifyResponse.data.amount,
      };
    } catch (error) {
      console.error("Cashfree payment error:", error);
      const message =
        error?.message ||
        error?.details ||
        "Payment could not be started. Please try again or contact support.";
      return {
        success: false,
        error: message,
      };
    }
  }
}

export default new CashfreeService();
